// Pricing helpers shared by quotation/order edit screens.

// Normalize a user-entered selling price to a safe number, enforcing a minimum
// (lowestSellPrice) floor. Used on blur so the field can hold transient/empty
// values while typing without ever producing NaN.
export function clampSellingPrice(rawValue, lowestSellPrice) {
  const floor = Number(lowestSellPrice) || 0;
  const parsed = parseFloat(rawValue);
  if (Number.isNaN(parsed)) return floor;
  return Math.max(parsed, floor);
}
